<footer class="app-footer">
  <!-- Help CTA section -->
  <section class="app-footer__help" aria-labelledby="footer-help-heading">
    <div class="app-footer__help-inner">
      <h2 id="footer-help-heading" class="app-footer__heading">Need help using EWRS?</h2>
      <p class="app-footer__desc">
        Find step-by-step instructions for, including booking workspaces, checking in, managing reservations, and
        understanding recent changes.
      </p>
      <a
        routerLink="/docs"
        (click)="onFooterRouterLinkClicked('/docs')"
        class="app-footer__cta"
        title="Open the Employee Workspace Reservation System user guide"
        id="fullguideHelpLink"
      >
        User guide
      </a>
    </div>
  </section>

  <!-- Legal / nav links section -->
  <section class="app-footer__legal" aria-label="Footer">
    <div class="app-footer__legal-inner">
      <ul class="app-footer__nav">
        <li>
          <a
            href="http://www.ontario.ca/page/accessibility"
            target="_blank"
            rel="noopener noreferrer"
            id="accessibilityLink"
            title="Go to accessibility page. Opens in a new window."
          >
            Accessibility
          </a>
        </li>
        <li>
          <a
            href="https://www.ontario.ca/page/privacy-statement"
            target="_blank"
            rel="noopener noreferrer"
            id="privacyLink"
            title="Go to privacy page. Opens in a new window."
          >
            Privacy
          </a>
        </li>
        <li>
          <a
            href="mailto:EWRSfeedback@ontario.ca"
            target="_top"
            rel="noopener noreferrer"
            id="contactUsLink"
            title="Contact us"
          >
            Contact us
          </a>
        </li>
        <li>
          <a
            href="https://www.ontario.ca/page/terms-use"
            target="_blank"
            rel="noopener noreferrer"
            id="termofUseLink"
            title="Go to terms of use page. Opens in a new window."
          >
            Terms of use
          </a>
        </li>
      </ul>

      <a
        class="app-footer__copyright"
        href="https://www.ontario.ca/page/copyright-information-c-queens-printer-ontario"
        target="_blank"
        rel="noopener noreferrer"
        id="siteCopyrightLink"
        title="Site copyright. Opens in a new window."
      >
        © King's Printer for Ontario, 2026
      </a>
    </div>
  </section>
</footer>
